import React from "react";
import ReactApexChart from "react-apexcharts";
import "./index.scss";

const buildOptions = (inputData) => {
  const categories = inputData?.xAxis || [];
  return {
    chart: {
      type: "line",
      toolbar: { show: false },
      animations: { enabled: true },
    },
    legend: { show: true },
    colors: ["#001A53", "#FF5533"],
    dataLabels: {
      enabled: true,
      background: { enabled: false },
      offsetY: -6,
        formatter: (value, data) => {
          // Only show target count on the first dot of the Target series
          if (data.seriesIndex === 1) {
            return data.dataPointIndex === 0 ? value : "";
          }
          return value;
        },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    markers: {
      size: 3,
    },
    xaxis: {
      categories,
      axisBorder: { show: true },
      axisTicks: { show: true },
      labels: { trim: false },
    },
    yaxis: {
      labels: {
        style: {},
        offsetX: 0,
        offsetY: 0,
      },
    },
    grid: { strokeDashArray: 4 },
  };
};

const buildSeries = (inputData) => {
  const yValues = inputData?.yAxis || [];
  const targetLine = yValues.map(() => inputData?.target ?? 0);
  return [
    { name: "Mis 12", data: yValues },
    { name: "Target", data: targetLine },
  ];
};

export function Mis12({ data }) {
  const options = buildOptions(data || {});
  const series = buildSeries(data || {});
  return (
    <div className="mis-map">
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height="100%"
        width="100%"
      />
    </div>
  );
}
